import AssertionEntity from '../../lib/FormValidator/Assertion/AssertionEntity';
import AssertionItem from '../../lib/FormValidator/Assertion/AssertionItem';
export class PlanillaPartidoOfflineAssertions extends AssertionEntity {
  private constructor() {
    super();
  }

  static build() {
    const instance = new this();
    instance.addAssertionForCampoDeJuego();
    return instance;
  }

  addAssertionForCampoDeJuego(key = 'campo_de_juego') {
    this.defineAssertionForProperty(
      key,
      AssertionItem.forClosure(
        (value) => {
          return value !== '';
        },
        key,
        'Campo de juego es obligatorio'
      )
    );
  }
}
